module.exports = __webpack_public_path__ + "img/medium-risk.2b58879e.png";